(() => {
  const explorerRoots = document.querySelectorAll(".jfl-category-explorer");

  explorerRoots.forEach((root) => {
    const methods = root.querySelectorAll("[data-explorer-method]");
    const panels = root.querySelectorAll("[data-method-panel]");
    if (!methods.length || !panels.length) return;

    const activateExplorer = (methodKey, subcategoryKey) => {
      methods.forEach((button) => {
        const isActive = button.dataset.explorerMethod === methodKey;
        button.classList.toggle("active", isActive);
        button.setAttribute("aria-selected", String(isActive));
      });

      panels.forEach((panel) => {
        const isActivePanel = panel.dataset.methodPanel === methodKey;
        panel.classList.toggle("active", isActivePanel);
        if (!isActivePanel) return;

        const subpanels = panel.querySelectorAll("[data-subcategory-panel]");
        const targetPanel = subcategoryKey
          ? panel.querySelector(`[data-subcategory-panel="${subcategoryKey}"]`)
          : subpanels[0];
        const targetKey = targetPanel?.dataset.subcategoryPanel || "";

        panel.querySelectorAll("[data-subcategory]").forEach((chip) => {
          chip.classList.toggle("active", chip.dataset.subcategory === targetKey);
        });
        subpanels.forEach((subpanel) => {
          subpanel.classList.toggle("active", subpanel === targetPanel);
        });
      });
    };

    methods.forEach((button) => {
      button.addEventListener("click", () => activateExplorer(button.dataset.explorerMethod));
    });

    root.addEventListener("click", (event) => {
      const chip = event.target.closest("[data-subcategory]");
      if (!chip || !root.contains(chip)) return;
      const content = chip.closest("[data-method-panel]");
      activateExplorer(content?.dataset.methodPanel || "tanago", chip.dataset.subcategory);
    });

    activateExplorer(methods[0]?.dataset.explorerMethod || "tanago");
  });

  const revealTargets = document.querySelectorAll(".jfl-home-section, .jfl-metrics, .jfl-newsletter-band, .jfl-seo-copy");
  if (revealTargets.length) {
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("in-view");
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.14 });
      revealTargets.forEach((target) => observer.observe(target));
    } else {
      revealTargets.forEach((target) => target.classList.add("in-view"));
    }
  }

  const mobileQuery = window.matchMedia("(max-width: 989px)");
  const carouselSelectors = [".jfl-education-grid", ".jfl-shop-band", ".jfl-product-rail", ".jfl-product-showcase-rail"];
  const carouselState = new WeakMap();

  const getSectionLabel = (scroller) => {
    const heading = scroller.closest("section")?.querySelector("h2");
    const headingText = heading?.textContent?.trim();
    return headingText || "homepage carousel";
  };

  const getScrollStep = (scroller) => {
    const firstCard = scroller.querySelector(".jfl-education-panel, .jfl-shop-tile, .jfl-product-card, .jfl-product-showcase-card");
    if (!firstCard) return Math.max(scroller.clientWidth * 0.84, 220);
    const styles = window.getComputedStyle(scroller);
    const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
    return firstCard.getBoundingClientRect().width + gap;
  };

  const updateCarouselButtons = (scroller) => {
    const state = carouselState.get(scroller);
    if (!state) return;

    const scrollMax = Math.max(scroller.scrollWidth - scroller.clientWidth, 0);
    const isScrollable = mobileQuery.matches && scrollMax > 12;
    const atStart = scroller.scrollLeft <= 8;
    const atEnd = scroller.scrollLeft >= scrollMax - 8;

    state.shell.classList.toggle("is-active", isScrollable);
    state.prevButton.disabled = !isScrollable || atStart;
    state.nextButton.disabled = !isScrollable || atEnd;
    state.shell.dataset.jflCarousel = isScrollable ? "active" : "inactive";
  };

  const ensureCarouselShell = (scroller) => {
    if (carouselState.has(scroller)) {
      updateCarouselButtons(scroller);
      return;
    }

    const parent = scroller.parentNode;
    if (!parent) return;

    const shell = document.createElement("div");
    shell.className = "jfl-mobile-carousel-shell";
    parent.insertBefore(shell, scroller);
    shell.appendChild(scroller);

    const prevButton = document.createElement("button");
    prevButton.type = "button";
    prevButton.className = "jfl-carousel-arrow jfl-carousel-arrow-prev";
    prevButton.setAttribute("aria-label", `Scroll ${getSectionLabel(scroller)} left`);

    const nextButton = document.createElement("button");
    nextButton.type = "button";
    nextButton.className = "jfl-carousel-arrow jfl-carousel-arrow-next";
    nextButton.setAttribute("aria-label", `Scroll ${getSectionLabel(scroller)} right`);

    shell.append(prevButton, nextButton);

    const moveByStep = (direction) => {
      scroller.scrollBy({
        left: getScrollStep(scroller) * direction,
        behavior: "smooth",
      });
    };

    prevButton.addEventListener("click", () => moveByStep(-1));
    nextButton.addEventListener("click", () => moveByStep(1));

    const sync = () => updateCarouselButtons(scroller);
    scroller.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);

    if ("ResizeObserver" in window) {
      const resizeObserver = new ResizeObserver(sync);
      resizeObserver.observe(scroller);
      Array.from(scroller.children).forEach((child) => resizeObserver.observe(child));
    }

    carouselState.set(scroller, { shell, prevButton, nextButton });
    sync();
  };

  const syncAllCarousels = () => {
    carouselSelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((scroller) => ensureCarouselShell(scroller));
    });
  };

  syncAllCarousels();

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", syncAllCarousels);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(syncAllCarousels);
  }

  window.addEventListener("load", syncAllCarousels, { once: true });
  window.setTimeout(syncAllCarousels, 280);
})();
